import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { EntityContractInput } from '@/lib/api/domains/entity-contracts';
import { keys } from '@/lib/query-keys';

/**
 * Send a contract to a partner entity. Mutate → invalidate the list (no
 * optimistic write — matches the financial-mutation rule the other slices
 * follow). The prototype action is "send contract"; the create/send verb is
 * one operation here.
 */
export function useSendEntityContract() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: EntityContractInput) => api.entityContracts.send(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: keys.entityContracts.lists(),
      });
    },
  });
}
